import type { GenerationDto, PresentationDto, PresentationSummaryDto } from '@pb/shared';
import { asList, get, patch, post, put, query } from './client';

export interface ChapterInput {
  title: string;
  subtitle: string;
  numbered: boolean;
  group_ids: number[];
}

export const listPresentations = async (projectId: number, tagIds: number[] = [], includeRetired = false) =>
  asList(
    await get<PresentationSummaryDto[] | { items: PresentationSummaryDto[] }>(
      `/projects/${projectId}/presentations${query({
        tag_ids: tagIds,
        include_retired: includeRetired ? true : undefined,
      })}`,
    ),
  );
export const createPresentation = (
  projectId: number,
  input: { name: string; subtitle?: string; description?: string; show_agenda?: boolean; show_dividers?: boolean },
) => post<PresentationDto>(`/projects/${projectId}/presentations`, input);
export const getPresentation = (id: number) => get<PresentationDto>(`/presentations/${id}`);
export const updatePresentation = (
  id: number,
  input: { name?: string; subtitle?: string; description?: string; show_agenda?: boolean; show_dividers?: boolean },
) => patch<PresentationDto>(`/presentations/${id}`, input);
export const setPresentationStructure = (id: number, baseRevision: number, chapters: ChapterInput[]) =>
  put<PresentationDto>(`/presentations/${id}/structure`, { base_revision: baseRevision, chapters });
export const copyPresentation = (id: number) => post<PresentationDto>(`/presentations/${id}/copy`, {});
export const retirePresentation = (id: number, confirm: string) =>
  post<PresentationDto>(`/presentations/${id}/retire`, { confirm });
export const unretirePresentation = (id: number) => post<PresentationDto>(`/presentations/${id}/unretire`, {});
export const generatePresentation = (id: number) => post<GenerationDto>(`/presentations/${id}/generate`, {});
export const listGenerations = async (id: number) =>
  asList(await get<GenerationDto[] | { items: GenerationDto[] }>(`/presentations/${id}/generations`));
